<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="3px"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle
      cx="10.5"
      cy="10.5"
      r="7.5"
    />
    <line
      x1="21"
      y1="21"
      x2="15.8"
      y2="15.8"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgSearch',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
